import i18n from '../i18n';

// Dates and numbers in the app's language rather than the browser's, so a Spanish UI on an
// English phone still says "domingo, 2 de noviembre"
export const formatDate = (date, options) => new Date(date).toLocaleDateString(i18n.language, options);

export const formatNumber = (number) => Number(number).toLocaleString(i18n.language);
